import axios from "axios";
import { api } from "./helper";
import CryptoJS from 'crypto-js';
import Utils from "@/project/Source/utils.js";


const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + JSON.parse(CryptoJS.AES.decrypt(window.localStorage.getItem('jwt'), 'secret_key').toString(CryptoJS.enc.Utf8));
  return Utils.applyRequestCorrelationId(config);
});

client.interceptors.response.use(
    (response) => {
        if (response.data.isSuccess == false || response.data.isSuccess == true) {
            if (response.data.isSuccess)
                return response;
            else {
                const message = Utils.FormatErrorWithCorrelationId(null, response);
                Utils.Alert(message);
            }
        } else {
            return response;
        }
    },
    (error) => {
        if (error.response?.status === 401) {
            Utils.redirectToLoginOnUnauthorized();
            return Promise.reject(error);
        }
        const message = Utils.FormatErrorWithCorrelationId(error);
        Utils.Alert(message);
        return Promise.reject(error);
    }
);

function UserBranch(item) {
  return client.post("User/UserBranch", item);
}
function UserByRole(item) {
  return client.post("User/UserByRole", item);
}

function Auth(id) {
  return client.get("Token/" + id);
}

export default {
  Auth,
  UserBranch,
  UserByRole
};
